import { GameId } from '@common'
import cx from 'classnames'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

import CoCOffers from '@/assets/images/storefronts/clashofclans/offers_ui_banner.png'
import { useBreakpoints } from '@/utils/useBreakpoints'

import { useGameSlug } from '../../game-provider'
import { StoreTypography } from '../typography/StoreTypography'

import styles from './Offers.module.scss'

const OffersHeader = () => {
  const t = useTranslations()
  const gameSlug = useGameSlug()
  const from = useBreakpoints().from
  const useLargeHeader = from('mobile')
  const isDesktop = from('tablet')

  const brawl = gameSlug === 'brawlstars'
  const BrawlOffersHeader = useLargeHeader ? 'offers-header' : 'offers-header-small'

  const offersHeader = (gameSlug: GameId) => {
    switch (gameSlug) {
      case 'clashofclans':
        return CoCOffers
      case 'clashroyale':
        return CoCOffers
      default:
        return CoCOffers
    }
  }

  return (
    <div className={cx(styles.headerContainer, styles[gameSlug])}>
      {brawl ? (
        <div
          className={styles.imageContainer}
          style={{ backgroundImage: brawl ? `url(/images/brawlstars/${BrawlOffersHeader}.svg)` : '' }}
        />
      ) : (
        <div className={styles.imageContainer}>
          <Image src={offersHeader(gameSlug)} alt="offers-heading-image" fill sizes="(max-width: 500px) 390px, 420px" />
        </div>
      )}

      <div id="offers" className={styles.headerText}>
        <StoreTypography tag="h2" textSize={isDesktop ? 'xl' : 'lg'} style="outlined">
          {t('offers_title')}
        </StoreTypography>
      </div>
    </div>
  )
}

export default OffersHeader
